export class UserReportConfig {
  id: number;
  name: string;
  username: string;
  config: string;
  sharedUsers: string[];
  createdOn: number;
  lastUpdatedOn: number;
}
